/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityGroup } from '../../models/facility-group';

export interface DeleteFacilityGroup$Params {
  facilityGroupId: number;
}

export function deleteFacilityGroup(http: HttpClient, rootUrl: string, params: DeleteFacilityGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityGroup>> {
  const rb = new RequestBuilder(rootUrl, deleteFacilityGroup.PATH, 'delete');
  if (params) {
    rb.path('facilityGroupId', params.facilityGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityGroup>;
    })
  );
}

deleteFacilityGroup.PATH = '/api/facilitygroup/{facilityGroupId}';
